// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, updateDoc, increment } from "firebase/firestore";
import { FIREBASE_API } from "./constants";

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: FIREBASE_API,
	authDomain: "netflix-gpt-55490.firebaseapp.com",
	projectId: "netflix-gpt-55490",
	storageBucket: "netflix-gpt-55490.appspot.com",
	messagingSenderId: "960652200122",
	appId: "1:960652200122:web:8bf7c73bc708a016eb5a83",
	measurementId: "G-VBYDYHSN8C",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth();
export const db = getFirestore(app);

export const trackInstagramClick = async () => {
	const ref = doc(db, "clickCounts", "instagram");
	try {
		await updateDoc(ref, {
			count: increment(1),
		});
	} catch (error) {
		console.error("Failed to track click:", error);
	}
};

export const trackLinktreeClick = async () => {
	const ref = doc(db, "clickCounts", "linktree");
	try {
		await updateDoc(ref, {
			count: increment(1),
		});
	} catch (error) {
		console.error("Failed to track Linktree click:", error);
	}
};

// export const trackLinktreeClick = () => {
// 	try {
// 		logEvent(analytics, "linktree_click");
// 	} catch (error) {
// 		console.error("Error tracking Linktree click:", error);
// 	}
// };
